<template>
  <form
    class="needs-validation d-flex flex-column content-center items-center"
    novalidate
    @submit.prevent="submit"
  >
    <div class="my-2 w-100">
      <input
        v-model="form.surveyToken"
        class="form-control text-center w-100"
        :class="getValidationClass('surveyToken')"
        type="text"
        placeholder="Entrez le jeton de 6 caractères"
        required
      />
      <div v-if="form.errors.surveyToken" class="invalid-feedback">
        {{ form.errors.surveyToken }}
      </div>
      <div v-if="form.errors.captchaToken" class="invalid-feedback">
        {{ form.errors.captchaToken }}
      </div>
    </div>
    <button
      type="submit"
      class="btn btn-primary my-2"
      :disabled="form.processing"
    >
      Récupérer le questionnaire
    </button>
  </form>
</template>

<script>
export default {
  data() {
    return {
      form: this.$inertia.form({
        surveyToken: null,
        captchaToken: null,
      }),
      wasValidatedOnce: false,
    }
  },
  methods: {
    async submit() {
      this.wasValidatedOnce = false
      this.form.captchaToken = await this.getCaptchaToken()
      this.form.post(this.$route('survey.findByToken'), {
        onFinish: () => (this.wasValidatedOnce = true),
        onError: (error) => {
          this.wasValidatedOnce = true
          console.error(error)
          this.$toasted.error('Erreur de la récupération')
        },
      })
    },
    getValidationClass(key) {
      return (this.form.errors[key] || this.form.errors.captchaToken) &&
        this.wasValidatedOnce
        ? 'is-invalid'
        : null
    },
    async getCaptchaToken() {
      await this.$recaptchaLoaded()
      return await this.$recaptcha('findByToken')
    },
  },
}
</script>
